var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, styled } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { BsChevronUp } from 'react-icons/bs';
import { cn } from 'hx-util';
export var InfoToggle = function (_a) {
    var title = _a.title, children = _a.children, contentClass = _a.contentClass, titleClass = _a.titleClass, _b = _a.variant, variant = _b === void 0 ? 'link' : _b, _c = _a.chevronColor, chevronColor = _c === void 0 ? 'black' : _c, onClick = _a.onClick;
    var _d = useState(false), isExpanded = _d[0], setIsExpanded = _d[1];
    function handleClick() {
        setIsExpanded(!isExpanded);
        onClick === null || onClick === void 0 ? void 0 : onClick();
    }
    return (_jsxs("div", __assign({ className: "grid place-items-center" }, { children: [_jsxs(Link, __assign({ component: "button", "aria-expanded": isExpanded, "aria-controls": "info-content", type: "button", variant: variant, onClick: handleClick, className: cn('flex items-center gap-2 mb-2', titleClass) }, { children: [title, isExpanded ? (_jsx(BsChevronUp, { size: "1rem", color: chevronColor })) : (_jsx(BsChevronUp, { size: "1rem", color: chevronColor, className: "transform rotate-180" }))] })), _jsx(AnimatePresence, { children: isExpanded && (_jsx(MotionWrapper, __assign({ id: "info-content", initial: "collapsed", className: cn('max-w-sm', contentClass), animate: "open", exit: "collapsed", variants: {
                        open: {
                            opacity: 1,
                            height: 'auto',
                            transition: { duration: 0.2 },
                        },
                        collapsed: {
                            opacity: 0,
                            height: 0,
                            transition: { duration: 0.2 },
                        },
                    } }, { children: children }), "content")) })] })));
};
var MotionWrapper = motion(styled('div')({
    overflow: 'hidden',
    textAlign: 'center',
    fontFamily: 'Quasimoda',
}));
